import PageShell from "@/components/PageShell";

export default function RefundPolicy() {
  return (
    <PageShell
      testid="refund-cancellation-page"
      eyebrow="Legal"
      title="Refund & Cancellation Policy."
      updated="26 September 2026"
    >
      <p>
        French Pie sells fresh, perishable food. This policy explains when and how you can cancel an order and how
        refunds work. It applies to orders placed on www.frenchpie.co.in.
      </p>

      <h2>1. Cancellations — how long you have</h2>
      <ul>
        <li>
          You may cancel a reserved pickup order <strong>until 9:00 PM IST on the day before your pickup slot</strong>{" "}
          — after we begin the overnight bake we cannot cancel without wasting food.
        </li>
        <li>
          <strong>Channels to cancel:</strong> call or WhatsApp <strong>+91 95967 66336</strong>, or email{" "}
          <strong>bemina@frenchpie.co.in</strong> with your order details.
        </li>
        <li>
          Prepaid (online-paid) orders cancelled in time are refunded in full; cash-on-pickup orders are simply
          cancelled with nothing to refund.
        </li>
      </ul>

      <h2>2. Returns &amp; exchanges</h2>
      <p>
        Because everything we sell is fresh food, we do <strong>not accept returns or exchanges</strong> once an
        order has been collected. If anything is wrong — a wrong item in your basket or a quality issue — tell us
        within <strong>24 hours</strong> of pickup with a photo, and we will offer a replacement of the item on your
        next visit or a refund, at your choice.
      </p>

      <h2>3. Refunds — mode and time</h2>
      <ul>
        <li>
          <strong>Mode of refund:</strong> refunded to the original payment method (UPI / card / wallet via Razorpay).
          Cash orders are refunded in cash at the counter or by UPI transfer.
        </li>
        <li>
          <strong>Time:</strong> we initiate refunds within <strong>2 working days</strong> of approving them; your
          bank or wallet typically posts the amount within <strong>5–7 working days</strong>.
        </li>
        <li>
          <strong>Policy validity:</strong> this policy, and any claim under it, is applicable for{" "}
          <strong>7 days</strong> from the date of pickup (except the 24-hour quality-report window above, which
          applies to perishable replacements).
        </li>
        <li>If an item you prepaid is unavailable, we refund that item in full — automatically, no request needed.</li>
      </ul>

      <h2>4. How to raise a refund or cancellation</h2>
      <p>
        Email <strong>bemina@frenchpie.co.in</strong> or call/WhatsApp <strong>+91 95967 66336</strong> (10:00 AM –
        10:00 PM). We acknowledge every request within 48 hours. If you are not satisfied with the outcome, raise it
        again with "Grievance" in the subject line and the owner will review it personally.
      </p>

      <h2>5. Governing law</h2>
      <p>
        This policy is governed by the laws of India; disputes are subject to the courts at Srinagar, Jammu &amp;
        Kashmir. Policy changes are posted on this page with a new "Last updated" date.
      </p>
    </PageShell>
  );
}
